import { ref, watch } from "vue";
import { useFieldsStore } from "@/stores/storeFieldData";

export const useValidation = (modelValue, options = {}) => {
	const storeField = useFieldsStore();

	const isValid = ref(false);
	const isTouched = ref(false);
	const textError = ref(null);
	const formPassword = ref(null);

	const validation = (field, rawValue = modelValue.value) => {
		isTouched.value = true;

		if (field === "firstName") {
			isValid.value = modelValue.value?.trim().length >= 2;
			textError.value = isValid.value ? "" : "Введите Имя";
			storeField.updateFields("firstName", "disabledBtn", isValid.value);
		}
		if (field === "fio") {
			isValid.value = modelValue.value?.trim().length >= 2;
			textError.value = isValid.value ? "" : "Введите ФИО";
			storeField.updateFields("fio", "disabledBtn", isValid.value);
		}

		if (field === "lastName") {
			isValid.value = modelValue.value?.trim().length >= 2;
			textError.value = isValid.value ? "" : "Введите Фамилию";
			storeField.updateFields("lastName", "disabledBtn", isValid.value);
		}

		if (field === "patronymic") {
			isValid.value = modelValue.value?.trim().length >= 2;
			textError.value = isValid.value ? "" : "Введите Отчество";
			storeField.updateFields("patronymic", "disabledBtn", isValid.value);
		}

		if (field == "phone") {
			const cleanNumber = (rawValue ?? "").replace(/\D/g, "").slice(0, 11);
			isValid.value = cleanNumber.length === 11;
			textError.value = isValid.value ? "" : "Введите номер телефона";
			storeField.updateFields("phone", "disabledBtn", isValid.value);
		}

		if (field === "email") {
			const emailPattern = /^(?![._%+\-])([A-Za-z0-9._%+\-]{1,})@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
			isValid.value = emailPattern.test(modelValue.value) && modelValue.value.length >= 5;
			textError.value = isValid.value ? "" : "Введите email";
			storeField.updateFields("email", "disabledBtn", isValid.value);
		}
        
		const now = new Date();
		const minDate = new Date("1900-01-01");
		if (field === "birthDate") {
			if (!modelValue.value || modelValue.value.trim() === '') {
				isValid.value = false;
				textError.value = "Введите дату рождения";
				storeField.updateFields("birthDate", "disabledBtn", isValid.value);
			} else {
				const date = new Date(modelValue.value);
				isValid.value = minDate <= date && date <= now;
				textError.value = isValid.value ? "" : "Неверный формат";
				storeField.updateFields("birthDate", "disabledBtn", isValid.value);
			}
		}

		if (field === "issueDate") {
			if (!modelValue.value || modelValue.value.trim() === '') {
				isValid.value = false;
				textError.value = "Введите дату выдачи";
				storeField.updateFields("issueDate", "disabledBtn", isValid.value);
			} else {
				const date = new Date(modelValue.value);
				isValid.value = minDate <= date && date <= now;
				textError.value = isValid.value ? "" : "Неверный формат";
				storeField.updateFields("issueDate", "disabledBtn", isValid.value);
			}
		}

        if (field == "series") {
			const raw = modelValue.value ?? "";
			isValid.value = raw.trim().length >= 4;
			textError.value = isValid.value ? "" : "Введите 4 цифры";
			storeField.updateFields("series", "disabledBtn", isValid.value);
		}

        if (field == "number") {
			const raw = modelValue.value ?? "";
			isValid.value = raw.trim().length >= 6;
			textError.value = isValid.value ? "" : "Введите 6 цифр";
			storeField.updateFields("number", "disabledBtn", isValid.value);
		}

        if (field == "issuedBy") {
			const raw = modelValue.value ?? "";
			isValid.value = raw.trim().length >= 4;
			textError.value = isValid.value ? "" : "Введите текст";
			storeField.updateFields("issuedBy", "disabledBtn", isValid.value);
		}

        if (field == "departmentCode") {
			const raw = modelValue.value ?? "";
			isValid.value = raw.trim().length >= 6;
			textError.value = isValid.value ? "" : "Введите 6 цифр";
			storeField.updateFields("departmentCode", "disabledBtn", isValid.value);
		}

        if (field == "inn") {
			const raw = modelValue.value ?? "";
			isValid.value = raw.trim().length >= 12;
			textError.value = isValid.value ? "" : "Введите 12 цифр";
			storeField.updateFields("inn", "disabledBtn", isValid.value);
		}

        if (field == "zipCode") {
			const raw = modelValue.value ?? "";
			isValid.value = raw.trim().length >= 6;
			textError.value = isValid.value ? "" : "Введите 6 цифр";
			storeField.updateFields("zipCode", "disabledBtn", isValid.value);
		}

        if (field == "city") {
			const raw = modelValue.value ?? "";
			isValid.value = raw.trim().length >= 2;
			textError.value = isValid.value ? "" : "Введите название города";
			storeField.updateFields("city", "disabledBtn", isValid.value);
		}

		if (field == "house") {
			const raw = modelValue.value ?? "";
			isValid.value = raw.trim().length >= 1;
			textError.value = isValid.value ? "" : "Введите номер дома";
			storeField.updateFields("house", "disabledBtn", isValid.value);
		}

        if (field == "street") {
			const raw = modelValue.value ?? "";
			isValid.value = raw.trim().length >= 2;
			textError.value = isValid.value ? "" : "Введите название улицы";
			storeField.updateFields("street", "disabledBtn", isValid.value);
		}

        if (field == "apartment") {
			const raw = modelValue.value ?? "";
			isValid.value = raw.trim().length >= 1;
			textError.value = isValid.value ? "" : "Введите номер квартиры";
			storeField.updateFields("apartment", "disabledBtn", isValid.value);
		}

		if (field == "bik") {
			const raw = modelValue.value ?? "";
			isValid.value = raw.trim().length >= 9;
			textError.value = isValid.value ? "" : "Введите 9 цифр";
			storeField.updateFields("bik", "disabledBtn", isValid.value);
		}
        

		if (field === "rules") {
			isValid.value = modelValue.value;
			storeField.updateFields("rules", "disabledBtn", isValid.value);
		}

		if (field === "agreement") {
			isValid.value = modelValue.value;
			storeField.updateFields("agreement", "disabledBtn", isValid.value);
		}

		if (field === "policy") {
			isValid.value = modelValue.value;
			storeField.updateFields("policy", "disabledBtn", isValid.value);
		}

		if (field === "agreeToAdvertising") {
			isValid.value = modelValue.value;
			storeField.updateFields("agreeToAdvertising", "disabledBtn", isValid.value);
		}

		if (field === "category") {
			isValid.value = modelValue.value !== "";
			storeField.updateFields("category", "disabledBtn", isValid.value);
		}

		

		if (field == "accountNumber") {
			const raw = modelValue.value ?? "";
			isValid.value = raw.replace(/\s/g, "").length >= 20;
			textError.value = isValid.value ? "" : "Введите 20 цифр";
			storeField.updateFields("accountNumber", "disabledBtn", isValid.value);
		}

		if (field == "password") {
			const raw = modelValue.value ?? "";
			isValid.value = raw.trim().length >= 6;
			formPassword.value = modelValue.value;
			textError.value = isValid.value ? "" : "Введите пароль";
			storeField.updateFields("password", "disabledBtn", isValid.value);
		}

		if (field == "passwordRepeat") {
			const raw = modelValue.value ?? "";
			const originalPassword = options?.originalPassword?.value || "";
			isValid.value = raw.trim().length >= 6 && raw === originalPassword;
			textError.value = isValid.value ? "" : "Повторите пароль";
			storeField.updateFields("passwordRepeat", "disabledBtn", isValid.value);
		}

		if (field == "id") {
			const raw = modelValue.value ?? "";
			isValid.value = modelValue.value !== null;
			storeField.updateFields("select", "disabledBtn", isValid.value);
		}
		if (field === "message") {
			isValid.value = modelValue.value?.trim().length >= 5;
			textError.value = isValid.value ? "" : "Введите сообщение";
			storeField.updateFields("message", "disabledBtn", isValid.value);
		}
	};

	return {
		validation,

		isTouched,
		isValid,
		textError,
	};
};
